import { Section, Text } from "@react-email/components";
import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import { tLayout } from "../../translations";
import { useReturnVariableValues } from "../../hooks/use-return-variable-values";
import type { ReturnRequestDateBlockProps } from "./types";

export function ReturnRequestDateEmailRenderer({
  theme,
  section,
  locale,
  defaultLocale,
}: ReturnRequestDateBlockProps) {
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const t = tLayout(locale, defaultLocale);
  const { createdAt, requestTimezone } = useReturnVariableValues().getRequestDate();

  // Rendered only for European customers (where the backend resolved a
  // trustworthy local timezone); otherwise nothing — mirrors the legacy
  // `ReturnRequestDate` component.
  if (!createdAt || !requestTimezone) return null;

  // Format here (not in the backend) so the date follows the email's own
  // language rather than the customer's request language.
  const dateLocale = locale || defaultLocale;
  const date = new Date(createdAt);
  const requestDate = new Intl.DateTimeFormat(dateLocale, {
    dateStyle: "long",
    timeZone: requestTimezone,
  }).format(date);
  const requestTime = new Intl.DateTimeFormat(dateLocale, {
    timeStyle: "short",
    timeZone: requestTimezone,
  }).format(date);

  return (
    <Section className="px-4">
      <Text
        className="m-0 text-base leading-[1.5] text-center"
        style={{ color: colors.text }}
      >
        {t("returnRequestDate.label", {
          date: requestDate,
          time: requestTime,
        })}
      </Text>
    </Section>
  );
}
